import { getEditableField } from '../store/selectors';
import { canUseSmsChannel } from '../utils/delivery-channels';
export var buildApiPayloadDeliveryChannelsFromStore = function (params) {
    var store = params.store, session = params.session;
    var state = store.getState();
    var usesCustomDeliveryChannels = getEditableField(state, 'usesCustomDeliveryChannels').value;
    var isSmsChannelEnabled = canUseSmsChannel({ session: session });
    return {
        sendEmail: !!getEditableField(state, 'sendEmail').value || !usesCustomDeliveryChannels,
        sendSms: !!getEditableField(state, 'sendSms').value || (!usesCustomDeliveryChannels && isSmsChannelEnabled),
        sendPush: !!getEditableField(state, 'sendPush').value || !usesCustomDeliveryChannels,
    };
};
export var buildStoreDeliveryChannelsFromApiCampaign = function (_a) {
    var campaign = _a.campaign, session = _a.session;
    var isSmsChannelEnabled = canUseSmsChannel({ session: session });
    var sendSmsValue = isSmsChannelEnabled ? !!campaign.sendSms : false;
    return {
        sendEmail: { value: !!campaign.sendEmail },
        sendSms: { value: sendSmsValue },
        sendPush: { value: !!campaign.sendPush },
        usesCustomDeliveryChannels: {
            value: [sendSmsValue, campaign.sendEmail, campaign.sendPush].some(function (val) { return !val; }),
        },
    };
};
